import { OrgTransaction, PublicTransaction } from '~/types'
import { EvmAddress } from '~/utils/address'
import { isVaultToken } from '~/utils/vault'

export const buildWatchAddresses = (
  transaction: OrgTransaction | PublicTransaction,
): EvmAddress.Type[] => {
  const addresses = new Set<EvmAddress.Type>([
    EvmAddress.format(transaction.smartAccountAddress),
  ])

  if (transaction.transactionRecipients) {
    transaction.transactionRecipients
      .filter((r) => EvmAddress.validate(r.recipientAddress))
      // Exclude vault contract addresses (e.g. Aave aUSDC) — they are DeFi
      // protocol intermediaries, not user-associated addresses.
      .filter((r) => !isVaultToken(transaction.chainId, r.recipientAddress))
      .forEach((recipient) => {
        addresses.add(EvmAddress.format(recipient.recipientAddress))
      })
  }

  return Array.from(addresses)
}
